<template>
  <div class="contents userMgt">
    <div class="title flexB">
      <h2>플래너 관리</h2>
    </div>
    <div class="box one filter">
      <div class="flex">
        <p class="bold">검색조건</p>
        <select v-model="inputMode">
          <option value="" selected disabled>선택</option>
          <option value="plannerName">플래너명</option>
          <option value="agency">소속</option>
        </select>
        <input type="text" v-model="searchWord" @keyup.enter="search" />
      </div>
      <!-- <div class="flex">
        <p class="bold">카테고리</p>
        <label> <input type="radio" value="" checked v-model="category" />전체 </label>
        <label>
          <input type="radio" value="HALL" v-model="category" />
          서울
        </label>
        <label>
          <input type="radio" value="HOTEL" v-model="category" />
          부산
        </label>
        <label>
          <input type="radio" value="HOUSE" v-model="category" />
          경남
        </label>
        <label>
          <input type="radio" value="OUTDOOR" v-model="category" />
          제주
        </label>
      </div> -->
      <div class="buttonWrap">
        <button class="basic" @click="search">검색</button>
        <button class="line" @click="reset">초기화</button>
      </div>
    </div>

    <div class="box one planner">
      <h2 class="bold">
        플래너 리스트
        <button class="right basic">
          <router-link to="/admin/plannermanage/register"
            >플래너 등록</router-link
          >
        </button>
      </h2>
      <table>
        <colgroup>
          <col style="width: 10%" />
          <col style="width: 10%" />
          <col style="width: 10%" />
          <col style="width: 15%" />
          <col style="width: 20%" />
          <col style="width: 15%" />
          <col style="width: 10%" />
          <col style="width: 15%" />
        </colgroup>
        <tr>
          <th>번호</th>
          <th>플래너명</th>
          <th>상태</th>
          <th>소속</th>
          <th>활동지역</th>
          <th>활동시간</th>
          <th>휴무일</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in plannerList" :key="i">
          <td>{{ total + 1 - (i + 1 + (currentPage - 1) * 10) }}</td>
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              data.plannerName
            }}</router-link>
          </td>
          <td>
            {{
              data.status == "COMPLETE"
                ? "계약중"
                : data.status == "FINISHED"
                ? "계약종료"
                : ""
            }}
          </td>
          <td>{{ data.agency }}</td>
          <td>{{ data.region.join() }}</td>
          <td>{{ data.workTime }}</td>
          <td>{{ data.holidays.join() }}</td>
          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <NoData v-if="isNodata" />
      <div class="pagination" v-if="plannerList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { fetchPlannerList } from "@/api/admin";
import NoData from "@/components/contents/Nodata";
import { format } from "@/mixins/format";
export default {
  name: "toymanage",
  mixins: [format],
  components: { NoData },
  data() {
    return {
      moment: moment,
      category: "",
      plannerList: [],
      inputMode: "",
      searchWord: "",
      total: 0,
      currentPage: 1,
      isNodata: false,
    };
  },
  computed: {
    ...mapState(["navbarState"]),
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "5-1");
  },
  mounted() {
    this.getPlannerList();
  },
  methods: {
    reset() {
      this.inputMode = "";
      this.searchWord = "";
      this.category = "";
      this.currentPage = 1;
      this.plannerList = [];
      this.total = 0;
      this.getPlannerList();
    },
    search() {
      if (this.searchWord && this.inputMode == "") {
        this.$alert("검색 조건을 선택해 주세요.", {
          confirmButtonText: "확인",
          center: true,
        });
        return;
      }
      this.getPlannerList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPlannerList();
    },
    handleMove(id) {
      this.$router.push({ name: "plannerregister", query: { id: id } });
    },
    getPlannerList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        inputMode: this.inputMode,
        category: this.category,
      };
      fetchPlannerList(params).then((res) => {
        if (res.data.status == 200) {
          this.plannerList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
        } else {
          this.$alert(res.data.message, {
            confirmButtonText: "확인",
            center: true,
          });
        }
      });
    },
  },
};
</script>
